<template>
  <div>
    <!-- SNACKBAR DE MODIFICACION DE ORDENES -->
    <v-snackbar :color="colorsnackbarAlert" v-model="snackbarAlert" :timeout="timeout" top>
      <v-icon>mdi-message</v-icon>
      {{ SnackbarTextAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarAlert = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <!-- DIALOG FULL SCREEN FOR VISOR PREGUNTAS -->
    <v-dialog v-model="VisorSomosHabiles" fullscreen hide-overlay persistent>
      <v-card v-show="!ejecutarState" color="#f5f5f5">
        <v-system-bar height="30" dark window color="primary">
          <v-icon>mdi-comment-question-outline</v-icon>
          <span>TEST SOMOS HÁBILES</span>
          <v-spacer></v-spacer> 
          <!-- <v-icon @click="$emit('close')">mdi-minus</v-icon> -->
          <!-- <v-icon disabled @click="maximizarOrmin()">mdi-checkbox-blank-outline</v-icon> -->
          <v-icon @click="$emit('close')">mdi-close</v-icon>
        </v-system-bar>
        <component :is="compNameIntro" :estadoComp="estadoComponenteIntro" :parametros="parametroCompIntro" @click="ejecutarSomosHabiles">
        </component>
      </v-card>
      <v-card v-show="ejecutarState">
        <v-system-bar height="30" dark window color="primary">
          <v-icon>mdi-comment-question-outline</v-icon>
          <span>TEST SOMOS HÁBILES</span>
          <v-spacer></v-spacer>       
          <div v-if="minutos">
              <RelojRegresivoSH
                  @expirado="timeOutSomosHabiles"
                  :minutos="minutos"
                  :id="parametros.items.idexamen"
                  :estado="estadoReloj"
                ></RelojRegresivoSH>
          </div>
          <!-- <v-icon @click="$emit('close')">mdi-minus</v-icon> -->
          <!-- <v-icon disabled @click="maximizarOrmin()">mdi-checkbox-blank-outline</v-icon> -->
          <!-- <v-icon disabled @click="$emit('close')">mdi-close</v-icon> -->
        </v-system-bar>
        <!-- VISOR PREGUNTAS INTERNO -->
        <template>    
          <v-window v-if="showAlertaResult" v-model="step">
            <v-window-item v-for="(respta, i) in arrayPreguntasYrespuestas" :value="i + 1" :key="i">
              <v-card-text>
                <br />
                <v-row justify="end" align-content="end">
                  <v-col cols="4" style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <h2>
                      <v-icon size="40" color="orange">mdi-comment-question-outline</v-icon>
                      Pregunta {{ i + 1 }}
                    </h2>
                  </v-col>
                  <v-col cols="8" style="
                      display: flex;
                      justify-content: end;
                      align-items: start;
                    ">                   
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="8" offset="2" class="pb-0">
                    <div class="pb-0 text-center">
                      <h1 class="pt-2 mb-0" v-html="respta.pregunta"></h1>
                    </div>
                  </v-col>
                  <v-col cols="8" offset="2" class="py-0">
                    <!-- SI PREGUNTA ES VERDADERO O FALSO O SI ES UNICA -->
                    <v-radio-group active-class v-if="respta.tipo_pregunta != 'res_mul'" v-model="radioGroup[i]">
                      <v-alert v-for="(resptar, n) of respta.respuestas" :key="n" v-model="alertRespuestaLive[n]"
                        color="blue" border="left" elevation="3" dense colored-border
                        :class="{ 'active-alert ripple-effect': resptar.idrespuesta === selectedOption }">
                        <v-radio checked @change="validaRespuesta('unico', resptar, respta, i)"
                          :label="formatLabel(resptar.respuesta)" :value="resptar.idrespuesta">
                        </v-radio>
                      </v-alert>
                    </v-radio-group>
                    <!-- SI PREGUNTA ES MULTIPLE -->
                    <v-list v-else>
                      <v-list-item-group v-model="checkboxesRespuestas[i]" multiple>
                        <div v-for="(resptar, n) in respta.respuestas" :key="n">
                          <v-alert @click="validaRespuesta('multiple', resptar, respta, i)" color="blue" border="left"
                            elevation="3" class="pa-0" dense colored-border>
                            <v-list-item :value="resptar" active-class="blue--text text--accent-4 p-0">
                              <template v-slot:default="{ active }">
                                <v-list-item-action>
                                  <v-checkbox :input-value="active" color="blue accent-4" hide-details></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ formatLabel(resptar.respuesta) }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                          </v-alert>
                        </div>
                      </v-list-item-group>
                    </v-list>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col cols="2" class="text-center">
                    <v-btn :disabled="step === 1" color="success" depressed @click="prevpageSimulador">
                      <v-icon>mdi-step-backward</v-icon>

                      Anterior
                    </v-btn>
                  </v-col>
                  <v-col cols="8" class="text-center align-self-center">
                    <v-progress-linear disabled v-model="cantPreguntas" height="20" rounded>
                      <strong>{{ Math.ceil(cantPreguntas) }}%</strong>
                    </v-progress-linear>
                  </v-col>
                  <v-col cols="2" class="text-center">
                    <v-btn v-if="step !== contadorPreguntas" :disabled="step === contadorPreguntas" color="primary"
                      depressed @click="nextpageSimulador">
                      Siguiente
                      <v-icon>mdi-step-forward</v-icon>
                    </v-btn>
                    <v-btn v-else :loading="loadingFinalizar" :disabled="loadingFinalizar" color="error" depressed
                      @click="guardarExamenResult(parametros.tipo_contenido, true)">
                      Finalizar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-window-item>
          </v-window>

          <v-card v-else color="amber lighten-5" style="margin-top: 5%" class="mx-auto" max-width="400">
            <v-card-title>
              <v-img :src="imgWinOrLose"> </v-img>
            </v-card-title>

            <v-card-text color="orange lighten-2" class="text-h5 orange--text text-center font-weight-bold">
              {{ congratulationOrLose }}
            </v-card-text>

            <v-card-actions>
              <v-list-item class="grow">
                <v-list-item-avatar color="grey darken-3">
                  <v-img class="elevation-6" alt=""
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>Puntaje:</v-list-item-title>
                </v-list-item-content>

                <v-row align="center" justify="center">
                  <span class="subheading mr-2"><strong>{{ aciertos }}</strong></span>
                  <v-icon class="mr-1" color="green"> mdi-check </v-icon>
                  <span class="mr-6">·</span>
                  <span class="subheading"><strong>{{ desaciertos }}</strong></span>
                  <v-icon class="mr-1" color="red"> mdi-close </v-icon>
                </v-row>
              </v-list-item>
            </v-card-actions>

            <br />
            <v-row style="display: block; text-align: center">
              <v-btn @click="$emit('close')" color="red" class="ma-2 white--text">
                CERRAR
              </v-btn>
            </v-row>
            <br /><br />
          </v-card>
        </template>
      </v-card>
    </v-dialog>
    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
    </component>
  </div>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
import RelojRegresivoSH from "../components/RelojCaducaSomosHabiles.vue";
import introExamenTemplate from "../../../../components/introExamenTemplate.vue";
//   import { mapState } from "vuex";
export default {
  name: "visorSomosHabiles",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {
    RelojRegresivoSH,
    introExamenTemplate
  },
  data: () => ({
    checkboxesRespuestas: [],
    settings: [],
    cantPreguntas: 0,
    step: 1,
    totalPag: null,
    contadorPreguntas: null,
    radioGroup: [],
    alertRespuestaLive: [], //LOGICA RESPUESTA DE SIMULADOR
    respuestasChecks: [], //LOGICA RESPUESTA DE SIMULADOR
    compName: null,
    estadoComponente: true,
    parametroComp: [],
    VisorSomosHabiles: true,
    ejecutarState: false,

    showAlertaResult: true,
    arrayPreguntasYrespuestas: [],
    itemArrayResultado: [],
    loadingFinalizar: false,

    congratulationOrLose: "",
    aciertos: 0,
    desaciertos: 0,
    imgWinOrLose: "",
    booleanValue: [],
    fechaInicio: null,
    // PROPIEDADES PARA ALERTA
    colorsnackbarAlert: "green",
    snackbarAlert: false,
    timeout: 1000,
    SnackbarTextAlert: "",
    readyloadStuden: true,
    notaPeru: null,
    resultadoVerExamen: null,
    selectedOption: null,
    minutos: null,
    estadoReloj:false,

    compNameIntro: null,
    estadoComponenteIntro: false,
    parametroCompIntro: {}
  }),
  mounted() {
    this.init();
  },
  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.init();
      } else {
        this.VisorSomosHabiles = false;
      }
    },
    VisorSomosHabiles(e) {
      if (!e) { //SI SE CIERRA EL VISOR SOMOS HÁBILES
        this.estadoReloj = false;
        this.arrayPreguntasYrespuestas = [];
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        this.$confetti.stop();
        this.$emit("close");
        this.showAlertaResult = true;
        this.limpiarSomosHabiles();
      }else{
        this.estadoReloj = true;
        this.minutos = this.parametros.tiempo_en_uso;
      }
    },
  },
  methods: {
    /** 
     ________________________________
    |          MÉTODO INIT         */
    init() {   

      this.VisorSomosHabiles = true;

      if (this.parametros.items.fecha_inicio) {
        this.ejecutarSomosHabiles();
      }else{
        this.callComponenteIntro();
      }
    },
    /** 
     _________________________________________________________
    |          MÉTODO MOSTRAR INTRODUCCION DE TEST          */
    callComponenteIntro(){

      this.ejecutarState = false;

      // CONVERSION DE DATOS:
      const isoDate = this.parametros.items.fecha_creacion;
      const dateObj = new Date(isoDate);

      const options = {
        weekday: 'long', // Nombre completo del día de la semana
        day: 'numeric', // Día del mes
        month: 'long', // Nombre completo del mes
        year: 'numeric' // Año en formato numérico completo
      };

      const formattedDate = dateObj.toLocaleDateString('es-ES', options);
      const dateText = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

      this.compNameIntro = 'introExamenTemplate';
      this.estadoComponenteIntro = true; 
      this.parametroCompIntro = {
        titulo: `SOMOS HÁBILES: ÁREA: ${this.parametros.datos.desc_area} TEMA: ${this.parametros.datos.nombre_clase}!`,
        subtitulo:'Somos hábiles no calificado',
        contenidoCuerpo: [
          { text: 'Fecha limite', subtext:`${dateText} a las 23:59 p.m`, icon: 'mdi-calendar' },
          { text: 'Intentos permitidos', subtext:'Tendrás permitido <strong> 1 intento </strong> para desarrollar tu somos hábiles.', icon: 'mdi-cached' },
          { text: 'Duración: 30 min', subtext:'Una vez finalizado el tiempo tus respuestas quedaran registradas en el sistema.', icon: 'mdi-clock' },
        ],
        contenidoAdicional:[  
          { text: 'Total de preguntas <strong style="font-size: 20px;"> 6 </strong>', icon: 'mdi-cube-outline' },
          { text: 'Revisa que tu conexión a internet sea estable antes de empezar.', icon: 'mdi-wifi' },
          { text: 'Una vez iniciado el test el cronometro seguira corriendo (30 minutos) aunque cierres y vuelvas a reiniciar la pagina.', icon: 'mdi-alert-octagon' },
          { text: 'Se recomienda repasar la clase antes de iniciar el test de los somos hábiles.', icon: 'mdi-comment-alert' },         

        ],
      };
    },
    /** 
     _________________________________________________________
    |          MÉTODO EJECUTAR TEST SOMOS HÁBILES         */
    ejecutarSomosHabiles(){
  
      const tipo_contenido = this.parametros.tipo_contenido;
      const idexamen = this.parametros.items.idexamen;
      const fecha_inicio = this.parametros.items.fecha_inicio;
      this.listarRespuestasPreguntas(tipo_contenido);

      this.ejecutarState = true;
      this.step = 1;
      this.estadoReloj = true;
      this.minutos = this.parametros.tiempo_en_uso;

      if (!fecha_inicio) {
        this.actualizarFechaInicio(tipo_contenido,idexamen);
      }
    },
    /** 
     ____________________________________________________
    |          MÉTODO CREAR FECHA INICIO SHab          */
    async actualizarFechaInicio(tipo_contenido,idexamen){
      let URI;
      if (tipo_contenido == 0) {
        URI = `/simulador/simuladorExamenColegio/simuladorAdmPreguntas/simuladorAdmP/actualizarAdmFechaSomosHabiles/${idexamen}`
      } else {
        URI = `/simulador/simuladorExamen/simuladorPreguntas/simuladorP/actualizarFechaSomosHabiles/${idexamen}`
      }
      try {        
       await axios.get(
          URI
        );
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     __________________________________________
    |          MÉTODO LABEL FORMATEO         */
    formatLabel(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    /** 
     ________________________________________________
    |          MÉTODO CADUCA SOMOS HABILES         */
    timeOutSomosHabiles(){
      this.guardarExamenResult(this.parametros.tipo_contenido, false) 
      setTimeout(() => {
        this.VisorSomosHabiles = false;
      }, 3000);
    },
    /** 
     _______________________________________________________
    |          MÉTODO LIMPIAR VISOR SOMOS HÁBILES         */
    limpiarSomosHabiles() {
      this.checkboxesRespuestas = [];
      this.itemArrayResultado = [];
      this.radioGroup = [];
      this.contadorPreguntas = null;
    },
    /** 
     ___________________________________________________
    |          MÉTODO PASAR PÁGINA SIMULADOR          */
    nextpageSimulador() {
      this.step++;

      if (this.step == 1) {
        this.cantPreguntas = this.totalPag * 0;
      } else {
        this.cantPreguntas = this.totalPag * this.step;
      }
      // me.cantPreguntas = me.totalPag * me.step;
    },
    /** 
     ______________________________________________________
    |          MÉTODO REGRESAR PÁGINA SIMULADOR          */
    prevpageSimulador() {
      const me = this;
      me.step--;

      if (me.step == 1) {
        me.cantPreguntas = me.totalPag * 0;
      } else {
        me.cantPreguntas = me.totalPag * me.step;
      }
    },
    /** 
     ____________________________________________________________________
    |          MÉTODO MAXIMIZAR O MINIMIZAR VENTANA SIMULADOR          */
    maximizarOrmin() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        document.documentElement.requestFullscreen();
      }
    },
    /** 
     ______________________________________________________________
    |          MÉTODO LISTAR RESPUESTA DE LAS PREGUNTAS          */
    async listarRespuestasPreguntas(tipo_contenido) {
      const me = this;

      let URI;
      if (tipo_contenido == 0) {
        URI = `/simulador/simuladorExamenColegio/simuladorAdmDetalles/simuladorAdmDE/listarAdmPdetalle/${this.parametros.items.idusuario}/lista/${this.parametros.items.idexamen}`;
      } else {
        URI = `/simulador/simuladorExamen/simuladorDetalles/simuladorDE/listarPdetalle/${this.parametros.items.idusuario}/lista/${this.parametros.items.idexamen}`;
      }

      me.fechaInicio = new Date(Date.now()).toISOString();
      me.radioGroup = [];
      document.documentElement.requestFullscreen();
      // me.idexamenFull = idexamen; event, idexamen, idusuario
      me.cantPreguntas = 0;
      me.arrayPreguntasYrespuestas = [];
      me.contadorPreguntas = null;
      me.totalPag = null;
      try {
        const response = await axios.get(URI);

        const datosRespuestas = response.data.map((number) => {
          return {
            tipo_pregunta: number.tipo_pregunta,
            idexamen: number.idexamen,
            idpregunta: number.idpregunta,
            pregunta: number.pregunta,
            respuestas: number.respuestas,
          };
        });

        me.arrayPreguntasYrespuestas = datosRespuestas;
        let contadorPag = datosRespuestas.length;
        me.contadorPreguntas = contadorPag;
        me.totalPag = 100 / contadorPag;
        me.VisorSomosHabiles = true;

        // setTimeout(async () => {
        //   NProgress.done();
        //   me.VisorSomosHabiles = true;
        //   document.documentElement.requestFullscreen();
        // }, 800);
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /** 
     ______________________________________________
    |          MÉTODO VALIDAR RESPUESTA          */
    async validaRespuesta(
      tipopregunta,
      respuestasArray,
      preguntaArray,
      posicion,
    ) {

      if (tipopregunta == "unico") {
        preguntaArray.respuestas.forEach(e => {
          if (e.idrespuesta == respuestasArray.idrespuesta) {
            e.valor_respuesta_marcada = true;
          } else {
            e.valor_respuesta_marcada = false;
          }
        });

        this.selectedOption = respuestasArray.idrespuesta;
        this.itemArrayResultado[posicion] = {
          idexamen: preguntaArray.idexamen,
          idpregunta: preguntaArray.idpregunta,
          valor_pregunta: respuestasArray.valor_respuesta,
          respuestas_marcadas: preguntaArray.respuestas
        };

      } else {          
        this.booleanValue = this.checkboxesRespuestas[posicion].map(objeto => objeto.idrespuesta)

        var resultado = true;
        var respuestasCorrectas = 0;
        var respuestasMarcadasCorrectas = 0;

        preguntaArray.respuestas.forEach((element) => {
          if (this.booleanValue.includes(element.idrespuesta)) {
            element.valor_respuesta_marcada = true;
          } else {
            element.valor_respuesta_marcada = false;
          }

          if (element.valor_respuesta === true) {
            respuestasCorrectas++;
            if (element.valor_respuesta_marcada === true) {
              respuestasMarcadasCorrectas++;
            }
          } else {
            if (element.valor_respuesta_marcada === true) {
              resultado = false;
            }
          }

        })

        if (respuestasMarcadasCorrectas !== respuestasCorrectas) {
          resultado = false;
        }

        this.itemArrayResultado[posicion] = {
          idexamen: preguntaArray.idexamen,
          idpregunta: preguntaArray.idpregunta,
          valor_pregunta: resultado,
          respuestas_marcadas: preguntaArray.respuestas
        };
      }
      console.log("*** --- PREGUNTAS RESPONDIDAS --- ***");
      console.log(this.itemArrayResultado);
    },
    /** 
     _____________________________________________________
    |          MÉTODO GUARDAR TEST RESULTADO          */
    async guardarExamenResult(tipo_contenido, valida) {
      const me = this;
      let URI;
      if (tipo_contenido == 0) {
        URI =
          "/simulador/simuladorExamenColegio/simuladorAdmDetalles/simuladorAdmDE/updateAdmDetalle/";
      } else {
        URI =
          "/simulador/simuladorExamen/simuladorDetalles/simuladorDE/updateDetalle/";
      }

      const fechaFin = new Date(Date.now()).toISOString();
      const fechaInicio_diferencia = new Date(me.fechaInicio);
      const fechaFin_diferencia = new Date(fechaFin);
      // Calcular la diferencia en milisegundos
      const diferenciaEnMilisegundos = fechaFin_diferencia - fechaInicio_diferencia;
      // Calcular horas, minutos y segundos
      const segundos = Math.floor(diferenciaEnMilisegundos / 1000);
      const minutos = Math.floor(segundos / 60);
      const horas = Math.floor(minutos / 60);
      // Calcular el residuo de minutos y segundos
      const segundosRestantes = segundos % 60;
      const minutosRestantes = minutos % 60;
      // Formatear la diferencia en HH:MM:SS
      const tiempoRecord = `${horas.toString().padStart(2, '0')}:${minutosRestantes.toString().padStart(2, '0')}:${segundosRestantes.toString().padStart(2, '0')}`;


      let cantidadp = this.itemArrayResultado.filter(
        (item) => Object.keys(item).length !== 0
      ).length;

      if (cantidadp != me.step && valida) {
        let preguntasquefaltan = Number(me.step) - Number(cantidadp);
        me.snackbarAlert = true;
        me.colorsnackbarAlert = "red";
        me.SnackbarTextAlert =
          "Te faltan contestar " + preguntasquefaltan + " pregunta (s)";
        return false;
      }

      me.showAlertaResult = false;
      me.loadingFinalizar = true;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      try {
        let aciertos = me.itemArrayResultado
          .map((obj) => obj.valor_pregunta)
          .reduce((acc, curr) => (curr ? acc + 1 : acc), 0);

        let result = (aciertos * 100) / cantidadp;
        let desaciertos = cantidadp - aciertos;

        me.aciertos = aciertos;
        me.desaciertos = desaciertos;

        if (result >= 60) {
          // <- 60%
          me.congratulationOrLose = "👏 ¡FELICIDADES! 👏";
          me.imgWinOrLose = "./imagenes/simulador_images/congratulations.webp";
          me.$confetti.start();
        } else {
          me.congratulationOrLose = "🥺 ¡BUEN INTENTO! 🥺";
          me.imgWinOrLose = "./imagenes/simulador_images/nicetry.jpg";
        }

        await axios.post(URI, {
          resultados: me.itemArrayResultado,
          idexamen: this.parametros.items.idexamen,
          fecha_inicio: me.fechaInicio,
          fecha_fin: fechaFin,
          tiempo_record: tiempoRecord,
        });

        setTimeout(async () => {
          NProgress.done();
          me.loadingFinalizar = false;
          // await me.listarExamen();
        }, 800);
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      } finally {
        this.estadoReloj = false;
        me.fechaInicio = null;
        this.estadoComponenteIntro = false;
        // this.$emit("close");
      }
    },
    /** 
     _________________________________________________
    |          MÉTODO CERRAR CONTEXTO LOCAL         */
    closeLocal() {
      this.$emit("close");
    },
    /** 
     __________________________________________________
    |          MÉTODO CERRAR CONTEXTO GLOBAL         */
    CloseModal() {
      this.VisorSomosHabiles = true;
      this.estadoComponente = false;
    },
  },
};
</script>

<style>
.ripple-effect {
  position: relative;
  overflow: hidden;
}

.ripple-effect::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background-color: #2c77b11f;
  transform: translate(-50%, -50%);
  /* border-radius: 50%; */
  opacity: 1;
  pointer-events: none;
  animation: rippleAnimation 1.5s linear;
}

.ripple-effect::active {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.363);
  transform: translate(-50%, -50%);
  /* border-radius: 50%; */
  opacity: 1;
  pointer-events: none;
  /* animation: rippleAnimation 55s linear; */
}

@keyframes rippleAnimation {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(8);
    opacity: 1;
  }
}

:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.377);
  /* border-radius: 50%; */
  opacity: 0;
  transition: all 0.3s ease;
  pointer-events: none;
}

.ripple-effect.ripple-effect::after {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}
</style>
